import {
  getBudgetReportDepList,
  getBudgetReportFormTypeList,
  queryBudgetReportProjectList,
  queryBudgetReportProjectSingleList,
  queryBudgetReportSubjectList,
  queryBudgetReportSubjectTotalList,
} from '../services/index';

export default {
  namespace: 'usageBudget',
  state: {},
  effects: {
    /**
     * 按预算项目_筛选项_预算部门
     */
    *getBudgetReportDepList({ payload }, { call }) {
      const result = yield call(getBudgetReportDepList, payload);
      return result;
    },
    /**
     * 预算项目报表列表
     */
    *queryBudgetReportProjectList({ payload }, { call }) {
      const result = yield call(queryBudgetReportProjectList, payload);
      return result;
    },
    /**
     * 按预算科目报表列表
     */
    *queryBudgetReportSubjectList({ payload }, { call }) {
      const result = yield call(queryBudgetReportSubjectList, payload);
      return result;
    },
    /**
     * 按预算项目_筛选项_业务场景
     */
    *getBudgetReportFormTypeList({ payload }, { call }) {
      const result = yield call(getBudgetReportFormTypeList, payload);
      return result;
    },
    /**
     * 按预算项目_单独_报表数据
     */
    *queryBudgetReportProjectSingleList({ payload }, { call }) {
      const result = yield call(queryBudgetReportProjectSingleList, payload);
      return result;
    },
    /**
     * 预算科目（总) 报表数据
     */
    *queryBudgetReportSubjectTotalList({ payload }, { call }) {
      const result = yield call(queryBudgetReportSubjectTotalList, payload);
      return result;
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
